module.exports = __webpack_public_path__ + "img/Black Diamond Spot 350 Headlamp.312d2200.jpg";